var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "157",
      "height": "175",
      "fill": "none"
    }
  }, _vm.$listeners), [_c('circle', {
    attrs: {
      "cx": "78.125",
      "cy": "78.125",
      "r": "78.125",
      "fill": "#005149"
    }
  }), _c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M6.51 62.5 19.53 75c32.357-31.062 84.831-31.062 117.188 0l13.021-12.5c-39.518-37.937-103.646-37.937-143.23 0zm52.083 50 19.531 18.75 19.532-18.75c-10.743-10.375-28.256-10.375-39.063 0m-26.042-25L45.572 100c17.969-17.25 47.136-17.25 65.104 0l13.021-12.5c-25.13-24.125-65.95-24.125-91.146 0"
    }
  }), _c('circle', {
    attrs: {
      "cx": "118.75",
      "cy": "143.75",
      "r": "29.75",
      "fill": "#005149",
      "stroke": "#fff",
      "stroke-width": "3"
    }
  }), _c('path', {
    attrs: {
      "fill": "#fff",
      "d": "m111.475 153.95-10.425-10.425-3.55 3.525 13.975 13.975 30-30-3.525-3.525z"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }